import React from "react";
import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="Last updated: June 2026" testid="terms-page">
      <Section heading="1. Who we are">
        <p>
          Mirror is owned and operated by <strong className="text-[var(--mirror-text)]">Gnosis
          Dynamics LLC</strong> ("we," "us," or "our"). By creating an account or using Mirror, you
          agree to these Terms of Service.
        </p>
      </Section>

      <Section heading="2. You must be 18 or older">
        <p>
          Mirror is intended strictly for adults. You must be at least{" "}
          <strong className="text-[var(--mirror-text)]">18 years of age</strong> to create an
          account or use the service. By using Mirror you represent and warrant that you meet this
          age requirement. If you do not, you may not use Mirror.
        </p>
      </Section>

      <Section heading="3. Mirror is not therapy or medical care">
        <p>
          <strong className="text-[var(--mirror-text)]">
            Mirror is an AI reflection tool for personal contemplation, not psychotherapy, medical
            care, or crisis intervention.
          </strong>{" "}
          It does not provide medical, psychological, legal, or professional advice, and it is not a
          substitute for care from a qualified professional.
        </p>
        <p>
          If you are experiencing a mental-health emergency or thoughts of self-harm, stop and
          contact your local emergency services or a crisis line immediately. Mirror cannot help in
          an emergency.
        </p>
      </Section>

      <Section heading="4. Acceptable use">
        <p>
          You agree to use Mirror only for lawful, personal reflection. You will not use it to
          harm yourself or others, to violate any law, or to attempt to disrupt or reverse-engineer
          the service.
        </p>
      </Section>

      <Section heading="5. Limitation of liability">
        <p>
          Mirror is provided "as is" and "as available," without warranties of any kind, express or
          implied. To the fullest extent permitted by law, Gnosis Dynamics LLC and its owners,
          employees, and affiliates shall not be liable for any indirect, incidental, special,
          consequential, or punitive damages, or for any loss arising from your use of, or reliance
          on, Mirror or anything it generates. Your use of Mirror is entirely at your own risk.
        </p>
      </Section>

      <Section heading="6. Changes">
        <p>
          We may update these Terms from time to time. Continued use of Mirror after changes take
          effect constitutes acceptance of the revised Terms.
        </p>
      </Section>
    </LegalLayout>
  );
}
